import React from 'react'
import AppView from './AppView'
import { BrowserRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { initApp } from 'store/app/actions'
import { selectAppInitialized } from 'store/app/reducer'
import Splash from 'components/Splash'
import LocalConfigPersist from 'components/LocalConfigPersist/index.'

class AppContainer extends React.Component {

    componentDidMount() {
        this.props.initApp()
    }

    render() {
        if (this.props.appInitialized) {
            return <BrowserRouter basename={'app'}>
                <AppView></AppView>
                <LocalConfigPersist />
            </BrowserRouter>
        } else {
            return <Splash />
        }
    }
}

const mapStateToProps = state => ({
    appInitialized: selectAppInitialized(state),
})

const mapDispatchToProps = {
    initApp,
}

export default connect(mapStateToProps, mapDispatchToProps)(AppContainer)
